@if(responseData.length){
  <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="responseData" dataKey="_id" [tableStyle]="{ 'min-width': '60rem' }"
  [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" autoLayout="true" [scrollable]="true">
    <ng-template pTemplate="header">
        <tr>
            <th>
                Role
            </th>
            <th>
                Position
            </th>
            <th>
              {{'Start Date/Time' | sentenceCase}}
            </th>
            <th>
                Received
            </th>
            @if (helperService.checkResponsive()) {
              <th alignFrozen="right" pFrozenColumn>
                <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
              </th>
              } @else {
              <th style="width:10%;">
                <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
              </th>
            }
            <ng-template #frozenHeader>
            Action
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" class="border-0" let-responseData let-expanded="expanded">
        <tr>
            <td>{{ responseData.roleType }}</td>
            <td> {{ responseData.positions }} listed / {{ responseData.positionsFilled }} filled
                  @if(responseData.presumptivelyPendingOfferCount){
                        / {{ responseData.presumptivelyPendingOfferCount }} pending
                  }
            </td>
            <td>
                @if (responseData.startAt) {
                {{responseData.startAt | date:'h:mma MM/dd/yyyy ' }}
                } @else {
                -
                }
            </td>
            <td>{{ responseData.offerQueuesCount }}</td>
            @if (helperService.checkResponsive()) {
              <td alignFrozen="right" pFrozenColumn>
                <ng-container *ngTemplateOutlet="frozenData"></ng-container>
              </td>
              } @else {
              <td>
                <ng-container *ngTemplateOutlet="frozenData"></ng-container>
              </td>
              } 
              <ng-template #frozenData>
                <div class="wrap-actions flex align-items-center gap-2">
                    <p-button [pTooltip]="expanded? 'Close' : 'Expand'" 
                    tooltipPosition="top" type="button" pRipple [pRowToggler]="responseData" [text]="true" [rounded]="true"
                        [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" class="row-toggler" />
                </div>
              </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <tr>
          <td colspan="7" class="p-0">
            <div class="sub-details py-3 px-4">
              <div class="grid grid-nogutter">
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">{{'Project Type' | sentenceCase}}</span>
                </div>
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                  @for(job of roleDetailsDisplay?.jobType; track job){
                    <p class="m-0 text-black-alpha-60 font-medium text-sm">
                      {{ job }}
                    </p>
                  }
                </div>
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">Education</span>
                </div>
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                  <span class="text-primary mt-2 block text-xs">Undergraduate</span>
                  @if(roleDetailsDisplay?.underGrad?.length){
                    @for(education of roleDetailsDisplay?.underGrad; track education){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">{{education.type}}-{{education.major}}</p>
                    }
                  } 
                  @else{
                    <p class="m-0 text-black-alpha-60 font-medium text-sm">Any</p>
                  }      
                </div>
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                <span class="text-primary mt-2 block text-xs">Graduate</span>
                @if(roleDetailsDisplay?.graduate?.length){
                    @for(education of roleDetailsDisplay?.graduate; track education){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">{{education.type}}-{{education.major}}</p>
                    }
                  }
                  @else{
                    <p class="m-0 text-black-alpha-60 font-medium text-sm">Any</p>
                  }
                </div>
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">{{'Skills and Experience' | sentenceCase}}</span>
                </div>
                @if(roleDetailsDisplay?.skillsAndExperience?.length){
                  <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                    @for(skill of roleDetailsDisplay?.skillsAndExperience; track skill){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">{{skill.val}}</p>
                    }
                  </div>
                }
                @else{
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">Any</p>
                }
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">Credentials</span>
                </div>
                @if(roleDetailsDisplay?.credential?.length){
                  <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                    @for(cred of roleDetailsDisplay?.credential; track cred){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">{{cred.val}}</p>
                    }
                  </div>
                }
                @else{
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">Any</p>
                }
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">{{'Timeline and Schedule' | sentenceCase}}</span>
                </div>
                @if(roleDetails.startAt){
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                  <span class="text-primary mt-2 block text-xs">Starts On</span>
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    {{ roleDetails.startAt | date}}
                  </p>
                </div>
                }
                @if(roleDetails.workSchedule.schedule.weekDays.willWork){
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                  @if(isPWCEnabled){
                  <span class="text-primary mt-2 block text-xs">{{'Required hours' | sentenceCase}}</span>
                  @if(roleDetails.workSchedule.schedule.weekDays.generalSelectedHour){
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    M-F ({{ roleDetails.workSchedule.schedule.weekDays.generalSelectedHour }})
                  </p>
                  }
                  @if(roleDetails.workSchedule.schedule.weekDays.potentialWeekendHours){
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    Potential weekend hours
                  </p>
                  }
                  } @else {
                  <span class="text-primary mt-2 block text-xs">Monday - Friday</span>
                  @if(formatTime(roleDetails.workSchedule.schedule.weekDays.time.start); as startTime){
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    Start {{ startTime }}
                  </p>
                  }
                  @if(formatTime(roleDetails.workSchedule.schedule.weekDays.time.end); as endTime){
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    End {{ endTime }}
                  </p>
                  }
                  }
                </div>
                }
                @if(roleDetails.workSchedule.duration){
                <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                  <span class="text-primary mt-2 block text-xs"
                    >{{'Expected Duration' | sentenceCase}}</span>
                  <p class="m-0 text-black-alpha-60 font-medium text-sm">
                    {{ roleDetails.workSchedule.duration | sentenceCase}}
                  </p>
                </div>
                }
                @if(roleDetails.workSchedule.duration !== 'Single Day or Shift'){
                  @if(roleDetails.workSchedule.schedule.saturday.willWork){
                    <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                      <span class="text-primary mt-2 block text-xs">Saturday</span>
                      @if(formatTime(roleDetails.workSchedule.schedule.saturday.time.start); as startTime){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">
                        Start {{ startTime }}
                      </p>
                      }
                      @if(formatTime(roleDetails.workSchedule.schedule.saturday.time.end); as endTime){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">
                        End {{ endTime }}
                      </p>
                      }
                    </div>
                  }
                  @if(roleDetails.workSchedule.workHours){
                    <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                      <span class="text-primary mt-2 block text-xs">Expected hours</span>
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">
                        {{ roleDetails.workSchedule.workHours }}
                      </p>
                    </div>
                  }
                  @if(roleDetails.workSchedule.schedule.sunday.willWork){
                    <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                      <span class="text-primary mt-2 block text-xs">Sunday</span>
                      @if(formatTime(roleDetails.workSchedule.schedule.sunday.time.start); as startTime){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">
                        Start {{ startTime }}
                      </p>
                      }
                      @if(formatTime(roleDetails.workSchedule.schedule.sunday.time.end); as endTime){
                      <p class="m-0 text-black-alpha-60 font-medium text-sm">
                        End {{ endTime }}
                      </p>
                      }
                    </div>
                  }
                }
                <div class="py-0 pr-4 pl-0 col-12 md:col-12 sm:col-12">
                  <span class="text-base block font-medium mt-3">{{'Screening Questions' | sentenceCase}}</span>
                </div>
                @if(roleDetails.hasConflict ){  
                  @if(roleDetails.scanForConflicts.specificQuestions){
                    @if(roleDetails.conflictQuestions.length){
                      <p-table [value]="roleDetails.conflictQuestions" class="py-0 pr-4 pl-0 col-12">
                        <ng-template pTemplate="header">
                          <tr class="table-data">
                            <th> 
                              Questions
                            </th>
                            <th class="td-center">
                              Answers
                            </th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-question>
                          <tr class="table-data surface-100">
                            <td>
                              <div class="inner-wrap p-0">
                                {{ question.title }}
                              </div>
                            </td>
                            <td class="td-center">
                              {{ question?.answer? 'Yes': 'No' }}
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>                      
                    }
                  }
                } @else {
                  <div class="py-0 pr-4 pl-0 col-2 md:col-2 sm:col-2">
                    <p class="m-0 text-black-alpha-60 font-medium text-sm">No screening questions</p>
                </div>
              }
                
              </div>
            </div>
          </td>
        </tr>
    </ng-template>
  </p-table>
  
}
@else {
  <span class="text-sm font-medium">No Roles Created</span>
}
